import React from 'react';
import cx from 'classnames';

import Text from 'components/Text';
import Image from 'components/Image';
import Link from 'components/Link';
import TooltipTrigger from 'components/TooltipTrigger';
import Icon from 'components/Icon';
import Button from 'components/ButtonDeprecated';

import './styles/ComposerIntegrationsContentItem.scss';

type Props = {
  item: any;
  registerHovercardTrigger: (x: any) => void;
  handleItemClicked: () => void;
  handleThumbnailClicked: () => void;
};

type State = {
  imageIsLandscape: boolean;
  imageLoadFailed: boolean;
};

class ComposerIntegrationsContentItem extends React.Component<Props, State> {
  state = {
    imageIsLandscape: false,
    imageLoadFailed: false,
  };

  thumbnail: Image | null = null;

  handleImageLoadFailure = () => {
    this.setState({
      imageLoadFailed: true,
    });
  };

  thumbnailLoaded = () => {
    if (this.thumbnail) {
      this.setState({
        imageIsLandscape: this.thumbnail?.isLandscape(),
      });
    }
  };

  showIconForFiletype = (mimeType: string) => {
    if (!mimeType) {
      return false;
    }
    if (mimeType === 'application/vnd.google-apps.folder') {
      return true;
    }
    if (mimeType.startsWith('video/')) {
      return true;
    }

    return false;
  };

  render = () => {
    const { imageLoadFailed, imageIsLandscape } = this.state;
    const {
      item,
      registerHovercardTrigger,
      handleItemClicked,
      handleThumbnailClicked,
      ...others
    } = this.props;
    const displayTitle = item.title || item.contentUrl;

    const showOverlay = item.imageUrl === '' || imageLoadFailed;

    const showIcon =
      item.imageUrl === '' || this.showIconForFiletype(item.mimeType) || imageLoadFailed;

    return (
      <Link {...others} className="ComposerIntegrationsContentItem" onClick={handleItemClicked}>
        <div className="ComposerIntegrationsContentItem-thumbnail">
          <Image
            ref={img => (this.thumbnail = img)}
            onLoad={this.thumbnailLoaded}
            onError={this.handleImageLoadFailure}
            className={cx('ComposerIntegrationsContentItem-thumbnail-image', {
              landscape: imageIsLandscape,
              portrait: !imageIsLandscape,
            })}
            src={item.imageUrl || ''}
          />
          {showOverlay && (
            <div
              className="ComposerIntegrationsContentItem-thumbnail-overlay"
              data-test="composer-integrations-content-item-overlay"
            />
          )}
          {showIcon && (
            <Image
              data-test="composer-integrations-content-item-thumbnail-icon"
              className="ComposerIntegrationsContentItem-thumbnail-icon"
              src={item.fileTypeIcon}
            />
          )}
        </div>
        <div className="ComposerIntegrationsContentItem-label">
          <TooltipTrigger tooltip={displayTitle} placement="top" alignment="left">
            <div className="ComposerIntegrationsContentItem-label-text">
              <Text color="chalkboard" size="xsmall" truncate>
                {displayTitle}
              </Text>
              {item.title && item.description && (
                <Text color="graphite" size="xxxsmall" truncate>
                  {item.description}
                </Text>
              )}
            </div>
          </TooltipTrigger>
          <TooltipTrigger tooltip="Preview" placement="top">
            <Button
              aria-label="Preview"
              className="ComposerIntegrationsContentItem-previewButton"
              size="xxsmall"
              level="icon"
              onClick={e => {
                handleThumbnailClicked();
                e.stopPropagation();
              }}>
              <Icon name="eye" size="medium" />
            </Button>
          </TooltipTrigger>
        </div>
      </Link>
    );
  };
}

export default ComposerIntegrationsContentItem;
